import React, { useEffect, useState, useMemo, useCallback } from "react";
import Moment from "react-moment";
import MeetingOptions from "../MeetingOptions";
import { getCurrentUser, loadUserDetails } from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import { useLoadSheduleMeetingQuery } from "../../app/store/candidateApiSlice";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import { getComponentUserStatus, UpdateComponentsUserStatus } from "../../app/store/tools";

const ROUTE_CANDIDATE = [{ name: "Task Management", url: "" }];
const ROUTE_PARTNER = [{ name: "Contract Management", url: "" }];

const SCHEDULE_MEETING_STYLES = {
  pageWrap: {
    padding: "8px 0 4px 0"
  },
  shell: {
    borderRadius: "0px",
    border: "1px solid #e5e5e5",
    backgroundColor: "#ffffff",
    boxShadow: "0 10px 30px rgba(15, 23, 42, 0.05)",
    overflow: "hidden"
  },
  hero: {
    padding: "14px 20px",
    borderBottom: "1px solid #e5e5e5",
    background: "#ffffff"
  },
  heroRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap"
  },
  heroCopy: {
    flex: "1 1 360px",
    minWidth: "280px",
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },
  titleIcon: {
    width: "32px",
    height: "32px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#ffffff",
    color: "#000000",
    fontSize: "14px",
    border: "1px solid #e5e5e5",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    flexShrink: 0
  },
  titleCopy: {
    minWidth: 0
  },
  title: {
    margin: 0,
    color: "#000000",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: 1.25
  },
  subtitle: {
    fontSize: "13px",
    lineHeight: 1.5,
    color: "#666666",
    margin: 0
  },
  heroActionRow: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  refreshButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    background: "transparent",
    border: "none",
    color: "#2563eb",
    padding: "0",
    fontSize: "13px",
    fontWeight: 500,
    cursor: "pointer",
    textDecoration: "none"
  },
  statusBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "7px 16px",
    borderRadius: "0px",
    border: "1px solid #e2e8f0",
    backgroundColor: "#f1f5f9",
    color: "#0f172a",
    fontSize: "12.5px",
    fontWeight: 600
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "14px",
    padding: "20px 22px"
  },
  statCard: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    backgroundColor: "#ffffff",
    border: "1px solid rgba(226, 232, 240, 0.95)",
    borderRadius: "0px",
    padding: "16px",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.04)",
    transition: "all 0.2s ease"
  },
  statIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
    color: "#0f172a",
    fontSize: "14px",
    flexShrink: 0
  },
  statContent: {
    minWidth: 0
  },
  statLabel: {
    margin: "0 0 4px 0",
    color: "#64748b",
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase"
  },
  statValue: {
    margin: 0,
    color: "#0f172a",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: 1
  },
  tableWrap: {
    padding: "0"
  },
  tableShell: {
    overflowX: "auto",
    backgroundColor: "#ffffff"
  },
  table: {
    width: "100%",
    marginBottom: 0,
    borderCollapse: "separate",
    borderSpacing: 0,
    fontSize: "13px",
    color: "#334155"
  },
  tableHeadCell: {
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    borderBottom: "1px solid #e5e5e5",
    padding: "14px 16px"
  },
  tableCell: {
    padding: "14px 16px",
    borderBottom: "1px solid #e2e8f0",
    verticalAlign: "top",
    fontWeight: 600
  },
  datePrimary: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "12.5px",
    fontWeight: 600,
    color: "#0f172a"
  },
  dateSecondary: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "2px",
    fontWeight: 600
  },
  optionList: {
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: "0px"
  },
  optionItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 0",
    borderBottom: "1px solid #e2e8f0",
    color: "#0f172a",
    fontSize: "12.5px",
    fontWeight: 500,
    whiteSpace: "nowrap"
  },
  acceptedItem: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 12px",
    borderRadius: "0px",
    backgroundColor: "#2dce898c",
    border: "1px solid #2dce89",
    color: "#0f172a",
    fontSize: "12.5px",
    fontWeight: 600,
    marginBottom: "6px"
  },
  meetingLinksWrap: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
    marginTop: "4px"
  },
  meetingLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    borderRadius: "0px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#0f172a",
    padding: "7px 14px",
    fontSize: "12.5px",
    fontWeight: 600,
    textDecoration: "none",
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)"
  },
  meetingProviderPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    borderRadius: "0px",
    border: "1px solid #e2e8f0",
    background: "#f8fafc",
    color: "#475569",
    padding: "5px 12px",
    fontSize: "12px",
    fontWeight: 600
  },
  infoText: {
    fontSize: "12.5px",
    color: "#475569",
    lineHeight: 1.5,
    fontWeight: 600
  },
  acceptedBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "6px 14px",
    borderRadius: "0px",
    backgroundColor: "#2dce898c",
    border: "1px solid #2dce89",
    color: "#0f172a",
    fontSize: "12px",
    fontWeight: 600
  },
  actionButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    background: "transparent",
    border: "none",
    color: "#2563eb",
    padding: "0",
    fontSize: "13px",
    fontWeight: 500,
    cursor: "pointer",
    textDecoration: "none"
  },
  emptyState: {
    padding: "42px 24px",
    textAlign: "center",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  emptyIcon: {
    width: "64px",
    height: "64px",
    margin: "0 auto 14px auto",
    borderRadius: "0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
    color: "#0f172a",
    fontSize: "26px"
  },
  emptyTitle: {
    margin: 0,
    color: "#0f172a",
    fontSize: "18px",
    fontWeight: 600,
    textAlign: "center"
  },
  emptyText: {
    fontSize: "13px",
    lineHeight: 1.5,
    color: "#666666",
    margin: "10px auto 0 auto",
    fontWeight: "normal"
  }
};

export default function ScheduleMeeting() {
  const [meetingShowHide, setMeetingShowHide] = useState(false);
  const [meetingObj, setMeetingObj] = useState("");

  const componentUserStatusSelector = useSelector(getComponentUserStatus);

  const usrType = localStorage.getItem("userType");

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  const usrId = currentUser?.linkUser || currentUser?.id;
  const currentUserId = currentUser?.id;

  useEffect(() => {
    dispatch(setCurrentPageTitle("Schedule Meeting"));
    dispatch(setCurrentRoute(usrType === "candidate" ? ROUTE_CANDIDATE : ROUTE_PARTNER));
  }, [dispatch, usrType]);

  // RTK Query hook for schedule meetings
  const {
    data: meetingSelector = [],
    isLoading: isMeetingsLoading,
    isFetching: isMeetingsFetching,
    refetch: refetchMeetings
  } = useLoadSheduleMeetingQuery(usrId, { skip: !usrId });

  const scheduleMeetings = meetingSelector;

  const isInitialLoading = isMeetingsLoading || (!usrId && !meetingSelector);
  const isDataFetching = isMeetingsFetching;
  const isDataLoading = isInitialLoading || (isDataFetching && scheduleMeetings.length === 0);

  const handleUpdateComponent = useCallback((compItems, ciid) => {
    const comp = componentUserStatusSelector.filter(x => x.compId === 11);
    let updCompItems = "";
    if (comp.length > 0) {
      updCompItems = comp[0].compItems;
    }
    const compObj = {
      compName: "Schedule Appointment",
      performerId: currentUserId,
      compItems: compItems,
      ciid: ciid,
      wiid: 0,
      iiid: 0,
      compId: 11
    };
    if (compItems !== "" && compItems !== updCompItems) {
      dispatch(UpdateComponentsUserStatus(compObj));
    }
  }, [componentUserStatusSelector, currentUserId, dispatch]);

  useEffect(() => {
    if (meetingSelector && meetingSelector.length > 0) {
      let schItems = "";
      meetingSelector.forEach((x, key) => {
        if (key > 0) schItems += ",";
        schItems += x.id;
      });
      handleUpdateComponent(schItems, meetingSelector[0].ciid);
    }
  }, [meetingSelector, handleUpdateComponent]);

  const handleMeetingModalShowHide = useCallback((meeting) => {
    setMeetingShowHide(prev => !prev);
    setMeetingObj(meeting);
    if (meeting === "save") {
      refetchMeetings();
    }
  }, [refetchMeetings]);

  const handleRefreshMeetings = useCallback(() => {
    let targetUsrId = currentUser?.linkUser || currentUser?.id;
    if (targetUsrId) {
      dispatch(loadUserDetails(targetUsrId));
    }
    if (refetchMeetings) {
      refetchMeetings();
    }
  }, [currentUser, dispatch, refetchMeetings]);

  const getAcceptedMeetingDate = useCallback((meetingOptions) => {
    const meeting = (meetingOptions || []).filter((x) => x.status === true);
    if (meeting.length > 0) {
      return (
        <div style={SCHEDULE_MEETING_STYLES.acceptedItem}>
          <i className="fa fa-calendar-check-o mr-1" style={{ color: "#166534", fontSize: "12px" }} aria-hidden="true"></i>
          <span style={{ fontWeight: 600, marginRight: "6px" }}>
            <Moment format="MMM Do, YYYY">{meeting[0].meetingDate}</Moment>
          </span>
          <span style={{ fontWeight: 500 }}>
            {meeting[0].startTime} - {meeting[0].endTime}
          </span>
        </div>
      );
    }
    return null;
  }, []);

  const getMeetingProviderLabel = useCallback((provider) => {
    if (provider === "meet") return "Google Meet";
    if (provider === "team") return "Microsoft Team";
    if (provider === "zoom") return "Zoom";
    return provider;
  }, []);

  const acceptedCount = useMemo(() => scheduleMeetings.filter((item) => item.status).length, [scheduleMeetings]);
  const pendingCount = useMemo(() => scheduleMeetings.length - acceptedCount, [scheduleMeetings, acceptedCount]);
  const totalOptions = useMemo(() => scheduleMeetings.reduce((sum, item) => sum + (item.options?.length || 0), 0), [scheduleMeetings]);

  return (
    <React.Fragment>
      <style>{`
        .sm-link-btn,
        .sm-link-btn:hover,
        .sm-link-btn:focus,
        .sm-link-btn.focus,
        .sm-link-btn:active,
        .sm-link-btn:not(:disabled):not(.disabled):active {
          background: none !important;
          background-color: transparent !important;
          border: none !important;
          box-shadow: none !important;
          outline: none !important;
          padding: 0 !important;
        }
        .sm-link-btn:hover {
          text-decoration: underline !important;
          color: #1d4ed8 !important;
        }
      `}</style>
      <div style={SCHEDULE_MEETING_STYLES.pageWrap}>
        <div style={SCHEDULE_MEETING_STYLES.shell}>
          <div style={SCHEDULE_MEETING_STYLES.hero}>
            <div style={SCHEDULE_MEETING_STYLES.heroRow}>
              <div style={SCHEDULE_MEETING_STYLES.heroCopy}>
                <div style={SCHEDULE_MEETING_STYLES.titleIcon}>
                  <i className="fa fa-calendar-check-o" aria-hidden="true"></i>
                </div>
                <div style={SCHEDULE_MEETING_STYLES.titleCopy}>
                  <h1 style={SCHEDULE_MEETING_STYLES.title}>Schedule Meetings</h1>
                  <p style={SCHEDULE_MEETING_STYLES.subtitle}>Review meeting requests, proposed time slots, and accepted appointments.</p>
                </div>
              </div>
              <div style={SCHEDULE_MEETING_STYLES.heroActionRow}>
                <button
                  type="button"
                  className="btn btn-sm sm-link-btn"
                  style={SCHEDULE_MEETING_STYLES.refreshButton}
                  onClick={handleRefreshMeetings}
                  disabled={isDataFetching}
                  title="Refresh Meetings"
                >
                  <i className={`fa fa-refresh ${isDataFetching ? "fa-spin" : ""}`} aria-hidden="true"></i>{" "}
                  {isDataFetching ? "Fetching..." : "Refresh"}
                </button>
                <span style={SCHEDULE_MEETING_STYLES.statusBadge}>
                  Pending Responses: {isDataLoading ? <i className="fa fa-circle-o-notch fa-spin ml-1" style={{ fontSize: "11px", color: "#64748b" }}></i> : pendingCount}
                </span>
              </div>
            </div>
          </div>

          {isDataFetching && scheduleMeetings.length > 0 && (
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "8px 18px",
              background: "#eff6ff",
              borderTop: "1px solid #bfdbfe",
              borderBottom: "1px solid #bfdbfe",
              color: "#1e40af",
              fontSize: "12px",
              fontWeight: 600
            }}>
              <div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                <i className="fa fa-circle-o-notch fa-spin" style={{ color: "#2563eb", fontSize: "13px" }}></i>
                <span>Fetching updated meeting schedules...</span>
              </div>
              <span style={{ fontSize: "11px", color: "#3b82f6", fontWeight: 500 }}>Updating</span>
            </div>
          )}

          <div style={SCHEDULE_MEETING_STYLES.statsGrid}>
            <div style={SCHEDULE_MEETING_STYLES.statCard}>
              <div style={SCHEDULE_MEETING_STYLES.statIcon}>
                <i className="fa fa-calendar" aria-hidden="true"></i>
              </div>
              <div style={SCHEDULE_MEETING_STYLES.statContent}>
                <div style={SCHEDULE_MEETING_STYLES.statLabel}>Total Meetings</div>
                <div style={SCHEDULE_MEETING_STYLES.statValue}>
                  {isDataLoading ? <i className="fa fa-circle-o-notch fa-spin" style={{ fontSize: "16px", color: "#64748b" }}></i> : scheduleMeetings.length}
                </div>
              </div>
            </div>
            <div style={SCHEDULE_MEETING_STYLES.statCard}>
              <div style={SCHEDULE_MEETING_STYLES.statIcon}>
                <i className="fa fa-check-circle-o" aria-hidden="true"></i>
              </div>
              <div style={SCHEDULE_MEETING_STYLES.statContent}>
                <div style={SCHEDULE_MEETING_STYLES.statLabel}>Accepted</div>
                <div style={SCHEDULE_MEETING_STYLES.statValue}>
                  {isDataLoading ? <i className="fa fa-circle-o-notch fa-spin" style={{ fontSize: "16px", color: "#64748b" }}></i> : acceptedCount}
                </div>
              </div>
            </div>
            <div style={SCHEDULE_MEETING_STYLES.statCard}>
              <div style={SCHEDULE_MEETING_STYLES.statIcon}>
                <i className="fa fa-clock-o" aria-hidden="true"></i>
              </div>
              <div style={SCHEDULE_MEETING_STYLES.statContent}>
                <div style={SCHEDULE_MEETING_STYLES.statLabel}>Awaiting Response</div>
                <div style={SCHEDULE_MEETING_STYLES.statValue}>
                  {isDataLoading ? <i className="fa fa-circle-o-notch fa-spin" style={{ fontSize: "16px", color: "#64748b" }}></i> : pendingCount}
                </div>
              </div>
            </div>
            <div style={SCHEDULE_MEETING_STYLES.statCard}>
              <div style={SCHEDULE_MEETING_STYLES.statIcon}>
                <i className="fa fa-list-ol" aria-hidden="true"></i>
              </div>
              <div style={SCHEDULE_MEETING_STYLES.statContent}>
                <div style={SCHEDULE_MEETING_STYLES.statLabel}>Time Options</div>
                <div style={SCHEDULE_MEETING_STYLES.statValue}>
                  {isDataLoading ? <i className="fa fa-circle-o-notch fa-spin" style={{ fontSize: "16px", color: "#64748b" }}></i> : totalOptions}
                </div>
              </div>
            </div>
          </div>

          <div style={SCHEDULE_MEETING_STYLES.tableWrap}>
            <div className="table-responsive" style={SCHEDULE_MEETING_STYLES.tableShell}>
              <table className="table align-items-center table-hover mb-0" style={SCHEDULE_MEETING_STYLES.table}>
                <thead>
                  <tr>
                    <th style={SCHEDULE_MEETING_STYLES.tableHeadCell}>ID</th>
                    <th style={SCHEDULE_MEETING_STYLES.tableHeadCell}>Date & Time</th>
                    <th style={SCHEDULE_MEETING_STYLES.tableHeadCell}>Meeting Date & Time (Options)</th>
                    <th style={SCHEDULE_MEETING_STYLES.tableHeadCell}>Meeting Date & Time (Accepted)</th>
                    <th style={SCHEDULE_MEETING_STYLES.tableHeadCell}>Notes</th>
                    <th style={SCHEDULE_MEETING_STYLES.tableHeadCell}>Status</th>
                  </tr>
                </thead>
                <tbody style={{ opacity: isDataFetching && scheduleMeetings.length > 0 ? 0.7 : 1, transition: "opacity 0.2s ease" }}>
                  {isDataLoading ? (
                    <tr>
                      <td colSpan={6} style={{ padding: "48px 20px", textAlign: "center", backgroundColor: "#ffffff" }}>
                        <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                          <div style={{ width: "40px", height: "40px", background: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center", color: "#000000", fontSize: "16px" }}>
                            <i className="fa fa-circle-o-notch fa-spin"></i>
                          </div>
                          <div style={{ fontSize: "14px", fontWeight: 600, color: "#0f172a" }}>
                            {isDataFetching ? "Fetching meetings..." : "Loading scheduled meetings..."}
                          </div>
                          <div style={{ fontSize: "12px", fontWeight: 500, color: "#64748b" }}>
                            Please wait while we retrieve your scheduled appointments.
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : scheduleMeetings.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="p-0">
                        <div style={SCHEDULE_MEETING_STYLES.emptyState}>
                          <div style={SCHEDULE_MEETING_STYLES.emptyIcon}>
                            <i className="fa fa-calendar" aria-hidden="true"></i>
                          </div>
                          <h4 style={SCHEDULE_MEETING_STYLES.emptyTitle}>No appointments scheduled yet</h4>
                          <p style={SCHEDULE_MEETING_STYLES.emptyText}>
                            Meeting requests and accepted appointment slots will appear here once they are created for your account.
                          </p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    scheduleMeetings.map((item, key) => (
                      <tr key={item.id || key}>
                        <td style={SCHEDULE_MEETING_STYLES.tableCell}>
                          <span style={{ color: "#0f172a", fontWeight: 700 }}>#</span>{" "}
                          <span style={{ fontWeight: 600, color: "#0f172a" }}>{item.id || key + 1}</span>
                        </td>
                        <td style={SCHEDULE_MEETING_STYLES.tableCell}>
                          <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                            <span style={{ fontSize: "13.5px", fontWeight: 600, color: "#0f172a" }}>
                              <Moment format="MMM Do, YYYY">
                                {item.createdDateTime}
                              </Moment>
                            </span>
                            <span style={{ fontSize: "12px", fontWeight: 600, color: "#64748b" }}>
                              <Moment format="h:mm a">
                                {item.createdDateTime}
                              </Moment>
                            </span>
                          </div>
                        </td>
                        <td style={SCHEDULE_MEETING_STYLES.tableCell}>
                          <div style={SCHEDULE_MEETING_STYLES.optionList}>
                            {(item.options || []).map((o, optionIndex) => (
                              <div
                                key={optionIndex}
                                style={{
                                  ...SCHEDULE_MEETING_STYLES.optionItem,
                                  ...(optionIndex === (item.options || []).length - 1 ? { borderBottom: "none" } : {})
                                }}
                              >
                                <i className="fa fa-clock-o mr-1" style={{ fontSize: "12px", color: "#94a3b8" }} aria-hidden="true"></i>
                                <span style={{ fontWeight: 600, color: "#0f172a", marginRight: "6px" }}>
                                  <Moment format="MMM Do, YYYY">
                                    {o.meetingDate}
                                  </Moment>
                                </span>
                                <span style={{ color: "#64748b", fontWeight: 500 }}>
                                  {o.startTime} - {o.endTime}
                                </span>
                              </div>
                            ))}
                          </div>
                        </td>
                        <td style={SCHEDULE_MEETING_STYLES.tableCell}>
                          {getAcceptedMeetingDate(item.options)}
                          {item.meetingProvider && (
                            <div style={SCHEDULE_MEETING_STYLES.meetingLinksWrap}>
                              {item.meetingProvider.split(",").map((m, key) => {
                                const trimmedProvider = m.trim();
                                if (!trimmedProvider) return null;
                                const providerLabel = getMeetingProviderLabel(trimmedProvider);
                                const linkUrls = item.meetingLinks ? item.meetingLinks.split(",") : [];
                                const linkUrl = linkUrls[key]?.trim();

                                return linkUrl ? (
                                  <a
                                    key={key}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={SCHEDULE_MEETING_STYLES.meetingLink}
                                    href={linkUrl}
                                  >
                                    <i className="fa fa-video-camera mr-1" aria-hidden="true"></i>
                                    Join {providerLabel}
                                  </a>
                                ) : (
                                  <span key={key} style={SCHEDULE_MEETING_STYLES.meetingProviderPill}>
                                    <i className="fa fa-video-camera mr-1" aria-hidden="true"></i>
                                    {providerLabel}
                                  </span>
                                );
                              })}
                            </div>
                          )}
                        </td>
                        <td style={{ ...SCHEDULE_MEETING_STYLES.tableCell, whiteSpace: "pre-wrap" }}>
                          <span style={SCHEDULE_MEETING_STYLES.infoText}>{item.remarks || "No notes available"}</span>
                        </td>
                        <td style={SCHEDULE_MEETING_STYLES.tableCell}>
                          {item.status ? (
                            <span style={SCHEDULE_MEETING_STYLES.acceptedBadge}>
                              <i className="fa fa-check" aria-hidden="true"></i> Accepted
                            </span>
                          ) : (
                            <button
                              className="btn btn-sm sm-link-btn"
                              style={SCHEDULE_MEETING_STYLES.actionButton}
                              onClick={() => handleMeetingModalShowHide(item)}
                            >
                              <i className="fa fa-check" aria-hidden="true"></i> Accept
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
      <MeetingOptions
        meetingShowHide={meetingShowHide}
        handleMeetingModalShowHide={handleMeetingModalShowHide}
        meeting={meetingObj}
      ></MeetingOptions>
    </React.Fragment>
  );
}
